<template>
    <template v-for="(structure, i) in value.structure" :key="i">
        <component :is="structure.component" v-model="value.structure[i]" :edit="edit" :create="create"/>
    </template>
</template>
<script>
import H1 from "@/components/calculations/H1.vue";
import H2 from "@/components/calculations/H2.vue";
import H3 from "@/components/calculations/H3.vue";
import Paragraph from "@/components/calculations/Paragraph.vue";
import Input from "@/components/calculations/Input.vue";
import Multiselect from "@/components/calculations/Multiselect.vue";
import Table from "@/components/calculations/Table.vue";
import Row from "@/components/calculations/Row.vue";
import Column from "@/components/calculations/Column.vue";
import Div from "@/components/calculations/Div.vue";
import Image from "@/components/calculations/Image.vue";
import Link from "@/components/calculations/Link.vue";
import Select from "@/components/calculations/Select.vue";
import Switch from "@/components/calculations/Switch.vue";

export default {
    components: {
        H1,
        H2,
        H3,
        Paragraph,
        Input,
        Table,
        Row,
        Column,
        Multiselect,
        Div,
        Image,
        Link,
        Select,
        Switch
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    }
}
</script>
<style lang="scss">
</style>